module.exports = __webpack_public_path__ + "img/icon.2549e375.png";